// src/pages/AccessDenied/RoleGuard.jsx
//
// Guard de ruta apoyado en user.modules (poblado por
// /api/MasterData/role-modules en AuthContext.runPostLoginFlow / switchRole).
// Cuando admin activa un módulo a un rol vía la matriz RBAC, el siguiente
// login (o switchRole) trae hasAccess=true y este guard lo deja pasar
// automáticamente — no hace falta tocar el frontend.
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext/AuthContext";
import { canUserAccessRoute } from "./roleRoutePermissions";

const RoleGuard = ({ children }) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  // Si no hay user, dejar pasar (ProtectedRoute ya maneja autenticación)
  if (!user) return children;

  if (!canUserAccessRoute(user, location.pathname)) {
    return <Navigate to="/AccessDenied" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export default RoleGuard;
